/*
 * File: ui-validate-ip.ts
 * File Created: 2024-09-13 09:08:54
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    EUITagRuleUnion,
} from "../core";

// @uiValidateIp - validate ip with regexp.
// allow value: null | IUIValidateIp
// default as: defaultData

type EUIValidateIPVersion = "v4" | "v6" | "all";
interface IUIValidateIp {
    "text-error": string;
    version: EUIValidateIPVersion;
}
const defaultData: IUIValidateIp = {
    "text-error": "w_RequireValidIPFormat",
    version: "v4",
};

const regex_ipv4 =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const regex_ipv6 =
    /^([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)|(([0-9a-fA-F]{1,4}:){1,7}|:)([0-9a-fA-F]{1,4}|:)(([0-9a-fA-F]{1,4}:){1,6}|:)(([0-9a-fA-F]{1,4}:){1,5}|:)(([0-9a-fA-F]{1,4}:){1,4}|:)(([0-9a-fA-F]{1,4}:){1,3}|:)(([0-9a-fA-F]{1,4}:){1,2}|:)([0-9a-fA-F]{1,4}|:)(([0-9a-fA-F]{1,4}:){1,1}|:)([0-9a-fA-F]{1,4}|:)$/;
const regex_ipv4_gradual =
    /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){0,3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)?$/;
const regex_ipv6_gradual = /^([0-9a-fA-F]{1,4}(:|::)?){0,7}([0-9a-fA-F]{1,4})?$/;

@UITag.set()
export class uiValidateIp extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule: any = this.parseRule(input) ?? defaultData;
        /// generize to object
        let ro: IUIValidateIp = {
            ...defaultData,
            ...rule,
        };

        let moreTags: IUITagMoreTagsUnit[] = [];
        const { element } = input.variables ?? {};
        const { version } = ro;

        moreTags.push({
            tag: "uiValidator",
            rule: (o) =>
                (!(version === "v4" || version === "all") || regex_ipv4.test(o.value)) &&
                (!(version === "v6" || version === "all") || regex_ipv6.test(o.value))
                    ? undefined
                    : { state: false, message: element?.$_(ro["text-error"]) },
        });
        return {
            specials: {
                moreTags,
            },
        };
    }
}
